/** Returns a youtube.com/embed/... URL, or null if `url` is not a recognized YouTube link. */
export function getYouTubeEmbedUrl(url) {
  if (!url || typeof url !== 'string') return null;
  const trimmed = url.trim();
  const embedInPath = trimmed.match(
    /(?:youtube-nocookie\.com|youtube\.com)\/embed\/([a-zA-Z0-9_-]{6,})/i
  );
  if (embedInPath) {
    const host = trimmed.includes('youtube-nocookie.com')
      ? 'www.youtube-nocookie.com'
      : 'www.youtube.com';
    return `https://${host}/embed/${embedInPath[1]}`;
  }
  const shortMatch = trimmed.match(/youtu\.be\/([a-zA-Z0-9_-]{6,})/i);
  if (shortMatch) return `https://www.youtube.com/embed/${shortMatch[1]}`;
  try {
    const u = new URL(trimmed);
    const host = u.hostname.replace(/^www\./, '');
    if (host === 'youtu.be') {
      const id = u.pathname.replace(/^\//, '').split('/')[0];
      return id && /^[a-zA-Z0-9_-]{6,}$/.test(id) ? `https://www.youtube.com/embed/${id}` : null;
    }
    if (host === 'youtube.com' || host === 'm.youtube.com' || host === 'music.youtube.com') {
      if (u.pathname === '/watch' || u.pathname.startsWith('/watch')) {
        const id = u.searchParams.get('v');
        return id && /^[a-zA-Z0-9_-]{6,}$/.test(id) ? `https://www.youtube.com/embed/${id}` : null;
      }
      const shorts = u.pathname.match(/^\/shorts\/([a-zA-Z0-9_-]{6,})/i);
      if (shorts) return `https://www.youtube.com/embed/${shorts[1]}`;
      const live = u.pathname.match(/^\/live\/([a-zA-Z0-9_-]{6,})/i);
      if (live) return `https://www.youtube.com/embed/${live[1]}`;
    }
  } catch {
    return null;
  }
  return null;
}
